import { render, staticRenderFns } from "./course-grouped-list.vue?vue&type=template&id=45e98858&scoped=true"
import script from "./course-grouped-list.vue?vue&type=script&lang=js"
export * from "./course-grouped-list.vue?vue&type=script&lang=js"
import style0 from "./course-grouped-list.vue?vue&type=style&index=0&id=45e98858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e98858",
  null
  
)

export default component.exports